module.exports = __webpack_public_path__ + "img/cooperative1_logo2.d48af498.jpg";